import { render, staticRenderFns } from "./addWebModal.vue?vue&type=template&id=63170f38&scoped=true"
import script from "./addWebModal.vue?vue&type=script&lang=js"
export * from "./addWebModal.vue?vue&type=script&lang=js"
import style0 from "./addWebModal.vue?vue&type=style&index=0&id=63170f38&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63170f38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63170f38')) {
      api.createRecord('63170f38', component.options)
    } else {
      api.reload('63170f38', component.options)
    }
    module.hot.accept("./addWebModal.vue?vue&type=template&id=63170f38&scoped=true", function () {
      api.rerender('63170f38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/addWebModal.vue"
export default component.exports